export interface MenuItem {
  name: string;
  price: string;
  description?: string;
  tags?: string[];
  isBestSeller?: boolean;
}

export interface MenuCategory {
  title: string;
  subtitle?: string;
  items: MenuItem[];
}

export const menuData: MenuCategory[] = [
  {
    title: "Appetizers",
    items: [
      {
        name: "Vegetable Spring Roll",
        price: "60K",
        description: "Deep fried vegetable spring roll served with sweet chilli sauce",
        tags: ["VG", "DF"],
        isBestSeller: true
      },
      {
        name: "Bruschetta",
        price: "55K",
        description: "Crispy slice baguette, tomato salsa, onion, basil and parmesan cheese",
        tags: ["VG"]
      },
      {
        name: "Garlic Cheese Bread",
        price: "55K",
        description: "Crispy slice baguette with mozzarela cheese",
        tags: ["VG"]
      },
      {
        name: "Chicken Caesar Salad",
        price: "80K",
        description: "Grill chicken breast, crispy bacon, egg, lettuce romaine, crispy slice baguette, parmesan cheese, served with caesar dressing",
        tags: ["Contains Pork"]
      },
      {
        name: "Tuna Tartare",
        price: "85K",
        description: "Slice fresh tuna with avocado smash and tomato salsa, dragon fruit mayo",
        tags: ["GF"]
      },
      {
        name: "Salmon Tartare",
        price: "90K",
        description: "Slice fresh salmon with avocado smash and tomato salsa, dragon fruit mayo",
        tags: ["GF"]
      },
      {
        name: "Tuna Tataki",
        price: "85K",
        description: "Pan-seared tuna loin with sesame seed, cucumber, avocado, served with dragon fruit mayo. Blue pea mayo and tomato salsa",
        tags: ["GF"]
      },
      {
        name: "Green Patal Kikian Salad",
        price: "60K",
        description: "Lettuce, mix capsicum, cucumber, onion, tomato, corn, avocado, red cabbage, served vinaigrette dressing",
        tags: ["V", "VG", "DF", "GF"]
      },
      {
        name: "Prawn Avocado Salad",
        price: "80K",
        description: "Grill prawn, slice avocado, cucumber, lettuce, onion, tomato, capsicum, served with cocktail dressing, blue pea mayo",
        tags: ["GF"]
      }
    ]
  },
  {
    title: "Soup",
    items: [
      {
        name: "Onion Soup",
        price: "55K",
        description: "Caramelized onion soup served with garlic cheese bread"
      },
      {
        name: "Tomato Corn Soup",
        price: "55K",
        description: "Creamy tomato and corn soup served with garlic cheese bread",
        tags: ["VG"]
      },
      {
        name: "Sea Food Tom Yam",
        price: "70K",
        description: "Tom yam soup with prawn, squid, fish, tomato, mushroom",
        tags: ["DF", "GF", "Spicy"]
      },
      {
        name: "Creamy Chicken Mushroom Soup",
        price: "60K",
        description: "Creamy soup with slice chicken, mushroom, served garlic cheese bread"
      }
    ]
  },
  {
    title: "Main Course",
    subtitle: "Balinese & Nusantara",
    items: [
      {
        name: "Bebek Rempah",
        price: "110K",
        description: "Crispy deep fried duck served with vegetable urab, steam rice, shallot relish",
        tags: ["DF", "GF"]
      },
      {
        name: "Crispy Chicken Sambel Matah",
        price: "85K",
        description: "Deep fried breded chicken breast served with vebatable urab, steam rice, shallot relish",
        tags: ["DF"]
      },
      {
        name: "Ayam Bakar Plecing",
        price: "90K",
        description: "Grill chicken leg with traditional red chilli sauce , served with vegetable urab and steam rice",
        tags: ["DF", "GF", "Spicy"]
      },
      {
        name: "Soto Ayam",
        price: "70K",
        description: "Yellow chicken soup with glass noodle, cabbage, bean sprout, tomato, shredded chicken, egg, served with steam rice",
        tags: ["DF", "GF"]
      },
      {
        name: "Ayam Kalio",
        price: "95K",
        description: "Slow braised chicken leg with kalio sauce and coconut milk, served with long bean kalasan, steam rice",
        tags: ["DF", "GF", "Spicy"]
      },
      {
        name: "Beef Rendang",
        price: "115K",
        description: "Stew meat beef with west sumatra rendang sauce served with long bean kalasan, steam rice",
        tags: ["DF", "GF"],
        isBestSeller: true
      }
    ]
  },
  {
    title: "Special Patal Kikian Balinese Menu",
    items: [
      {
        name: "Ulam Segara",
        price: "120K",
        description: "A mixture of seafood combined with Balinese cuisine with fish wrap banana leaves, grill prawn and grill squid red sauce, fish satay, fried fish, served with steam rice, vegetable urab, shallot relish",
        tags: ["DF", "Spicy"]
      },
      {
        name: "Bali Tulen",
        price: "150K",
        description: "A combination of Balinese pork dishes with authentic Balinese sauce, vegetable urab, pork satay, Balinese sausage, shredded pork belly, sweet crispy bean curd, kuah komoh soup, served steam rice , shallot relish",
        tags: ["DF", "GF", "Spicy", "Contains Pork"]
      },
      {
        name: "Segara Gunung For 2 Person",
        price: "260K",
        description: "A blend of balinese cuisine, a combination of sea product (segara / sea) with land product (gunung / mountains). Fish wrap banana leaves, grill prawn, fish shallot relish, steam chicken wrap banana leaves, crispy duck, chicken & beef satay, long bean kalasan, vegetable urab, red Balinese sauce and shallot relish, steam rice",
        tags: ["DF", "GF", "Spicy"]
      }
    ]
  },
  {
    title: "Asian",
    items: [
      {
        name: "Avocado Chicken Teriyaki",
        price: "80K",
        description: "Pan-seared slice chicken breast with teriyaki sauce served with steam rice, slice avocado, slice cucumber",
        tags: ["DF"]
      },
      {
        name: "Pad Thai Prawn",
        price: "85K",
        description: "The most popular thai noodles with prawn, tofu, and tamarin sauce",
        tags: ["DF", "Contains Nut"],
        isBestSeller: true
      },
      {
        name: "Chinese Fried Rice",
        price: "80K",
        description: "Chinese style fried rice with chicken, vegetable, fried crispy chicken, fried egg, colo-colo sauce, and crackers",
        tags: ["DF"]
      }
    ]
  },
  {
    title: "Western",
    items: [
      {
        name: "Pork Char Siu",
        price: "100K",
        description: "Slice pan-seared pork loin with Chinese hoisin sauce, served with hainan rice, sauteed pok coy and mushroom",
        tags: ["GF", "Contains Pork"]
      },
      {
        name: "Creamy Chicken Asparagus",
        price: "90K",
        description: "Creamy lemon mushroom sauce with chicken breast, asparagus, served with potato wedges",
        tags: ["GF"]
      },
      {
        name: "Panseared Chicken Cermulatte",
        price: "95K",
        description: "Pan-seared chicken breast cermulatte sauce, served with vegetable, potato wedges, creamy blue pea sauce, beetroot pure",
        tags: ["GF"]
      },
      {
        name: "BBQ Pork Ribs",
        price: "160K",
        description: "Grill bbq pork ribs, served with bbq sauce, vegetable and mash purple potato, pumpkin puree",
        tags: ["GF", "Contains Pork"]
      },
      {
        name: "Tenderloin Meltique",
        price: "190K",
        description: "Grill tenderloin meltique, served with vegetable, potato wedges, and black pepper sauce, beetroot puree",
        tags: ["GF", "MR", "M", "MW", "W"]
      },
      {
        name: "Sirloin Steak",
        price: "180K",
        description: "Grill sirloin steak, served with vegetable, potato wedges, and black pepper sauce, beetroot puree",
        tags: ["GF", "MR", "M", "MW", "W"]
      },
      {
        name: "Grill Octopus",
        price: "120K",
        description: "Grill octopus served with vegetable, mash purple potato, and coriander pesto sauce, pumpkin puree",
        tags: ["GF"]
      },
      {
        name: "Panseared Salmon",
        price: "180K",
        description: "Pan-seared salmon served with vegetable, mash purple potato and creamy pesto sauce, pumpkin puree",
        tags: ["GF"]
      },
      {
        name: "Grill Tuna",
        price: "120K",
        description: "Grill tuna loin served with vegetable, mash purple potato, caper lemon garlic butter sauce, pumpkin puree",
        tags: ["GF", "MR", "M", "MW", "W"]
      },
      {
        name: "Grill Prawn",
        price: "120K",
        description: "Grill prawn with red honey sauce, served with vegetable, mash purple potato, and dabu dabu sauce, pumpkin puree",
        tags: ["GF", "Spicy"]
      }
    ]
  },
  {
    title: "Pasta",
    items: [
      {
        name: "Spaghetti / Fettuccine Carbonara",
        price: "85K",
        description: "Pasta with egg yolk, crispy bacon, and parmesan cheese and crispy bread",
        tags: ["Contains Pork"]
      },
      {
        name: "Spaghetti / Fettuccine Teriyaki",
        price: "90K",
        description: "Combination pasta pesto served with slice chicken teriyaki sauce, asparagus, parmesan cheese, crispy bread"
      },
      {
        name: "Spaghetti / Fettuccine Ala Funghi",
        price: "85K",
        description: "Creamy pasta with slice mushroom, slice chicken, egg yolk, parmesan cheese, crispy bread"
      },
      {
        name: "Spaghetti / Fettuccine Aglio E Olio",
        price: "70K",
        description: "Pasta with sauteed slice garlic, parsley, olive oil, parmesan cheese, crispy bread",
        tags: ["VG"]
      }
    ]
  },
  {
    title: "Pizza",
    items: [
      {
        name: "Margarita Pizza",
        price: "80K",
        description: "Homemade tomato sauce, fresh tomato, basil, oregano, and mozzarella cheese",
        tags: ["VG"]
      },
      {
        name: "Chicken Corn Pizza",
        price: "95K",
        description: "Homemade tomato sauce, with slice chicken, sweet corn, tomato, onion, basil, mozzarella cheese"
      },
      {
        name: "Leaf Forest Pizza",
        price: "105K",
        description: "Homemade tomato sauce, with onion, capsicum, tomato, chicken sausage, bacon, slice egg, basil, and mozzarela cheese",
        tags: ["Contains Pork"]
      }
    ]
  },
  {
    title: "Sandwich, Burger & Kids Menu",
    items: [
      {
        name: "Triple Decker Sandwich",
        price: "80K",
        description: "Grill chicken breast, bacon, lettuce, onion, tomato, egg, cucumber, cheese, and potato wedges",
        tags: ["Contains Pork"]
      },
      {
        name: "Beef Burger",
        price: "85K",
        description: "Beef homemade patties, onion, tomato, cucumber, cheese, and potato wedges"
      },
      {
        name: "Chicken Burger",
        price: "75K",
        description: "Chicken homemade patties, onion, tomato, cucumber, cheese, and potato wedges"
      },
      {
        name: "Fish and Chips",
        price: "80K",
        description: "Crispy fried fish with potato wedges and tartar sauce"
      },
      {
        name: "Beef Baguette",
        price: "90K",
        description: "Slice meat beef with cheese and demiglass sauce, capsicum, onion, tomato, cucumber, lettuce and potato wedges"
      },
      {
        name: "Chicken Nugget",
        price: "60K",
        description: "Served with french fries and tomato ketchup"
      },
      {
        name: "Macaroni Mac and Cheese",
        price: "50K",
        description: "Macaroni pasta with creamy sauce and cheese, crispy bread"
      }
    ]
  },
  {
    title: "Vegetarian",
    items: [
      {
        name: "Avocado Toast",
        price: "65K",
        description: "With asparagus, tomato cherry, avocado, mushroom, glazed balsamic dressing",
        tags: ["V", "VG", "DF"]
      },
      {
        name: "Tofu and Tempe Curry",
        price: "60K",
        description: "Vegatarian yellow curry with tofu and tempeh, vegetable, coconut milk, served with steam rice",
        tags: ["V", "VG", "DF", "GF"]
      },
      {
        name: "Tempeh Steak",
        price: "70K",
        description: "Homemade tempeh steak with vegetable, potato wedges and sweet chilli sauce, pumpkin puree",
        tags: ["V", "VG", "DF"]
      },
      {
        name: "Gado Gado",
        price: "55K",
        description: "Blanch vegetable, fried tofu, fried bean cake, egg, crackers, served peanut sauce",
        tags: ["VG", "DF", "GF", "Contains Nut"]
      }
    ]
  },
  {
    title: "Organic Food",
    items: [
      {
        name: "Mie Ayam Kampung",
        price: "75K",
        description: "Homemade organic noodle, shreddeed chicken, blanch vegetable, organic chicken egg",
        tags: ["DF"]
      },
      {
        name: "Betutu Ayam Kampung",
        price: "110K",
        description: "Slow cooking chicken organic with Balinese sauce, braised long bean, steam rice",
        tags: ["DF", "GF"]
      }
    ]
  },
  {
    title: "Side Dish",
    items: [
      { name: "Steam Rice", price: "25K" },
      { name: "Potato Wedges", price: "35K" },
      { name: "French Fries", price: "35K" },
      { name: "Sauteed Vegetable", price: "35K" },
      { name: "Extra 1 Egg", price: "10K" }
    ]
  },
  {
    title: "Dessert",
    items: [
      {
        name: "Chocolate Lava",
        price: "55K",
        description: "Chocolate lava cake served with ice cream, strawberry coulis, cherry",
        isBestSeller: true
      },
      {
        name: "Chocolate Cake",
        price: "60K",
        description: "Chocolate cake served with ice cream, strawberry coulis, cherry"
      },
      {
        name: "Cream Brulee",
        price: "65K",
        description: "Cream brulee served ice cream"
      },
      {
        name: "Chocolate Mousse",
        price: "60K",
        description: "Chocolate mousse served with ice cream"
      },
      {
        name: "Tiramisu Cake",
        price: "70K",
        description: "Tiramisu cake served with ice cream, chocolate cocoa powder, cherry"
      },
      {
        name: "Tape Cheese Cake",
        price: "65K",
        description: "Fermented cassava cake with cream cheese and sour cream, served with ice cream, blue pea yogurt, dragon fruit yogurt, cherry"
      },
      {
        name: "Snack Fruit Pie",
        price: "60K",
        description: "Local Karangasem snack fruit pie with raisin and brown sugar, served with ice cream, blue pea yogurt, dragon fruit yogurt, cherry"
      }
    ]
  },
  {
    title: "Juice",
    items: [
      { name: "Banana Juice", price: "37K" },
      { name: "Lime Juice", price: "37K" },
      { name: "Papaya Juice", price: "37K" },
      { name: "Orange Juice", price: "37K" },
      { name: "Pineapple Juice", price: "37K" },
      { name: "Mango Juice (Seasonal)", price: "37K" },
      { name: "Watermelon Juice", price: "37K" },
      { name: "Apple Juice", price: "37K" },
      { name: "Avocado Juice (Seasonal)", price: "37K" },
      { name: "Tomato Juice", price: "37K" }
    ]
  },
  {
    title: "Soft Drink",
    items: [
      { name: "Sprite", price: "25K" },
      { name: "Coca Cola", price: "25K" },
      { name: "Diet Cola", price: "25K" },
      { name: "Soda Water", price: "25K" },
      { name: "Tonic Water", price: "25K" },
      { name: "Sparkling Water", price: "25K" }
    ]
  },
  {
    title: "Refreshment",
    items: [
      { name: "Small Mineral Water", price: "19K" },
      { name: "Small Beer Bintang", price: "38K" },
      { name: "Small Beer Bintang (Radler Lemon)", price: "38K" }
    ]
  },
  {
    title: "Smoothies",
    items: [
      { name: "Banana Smoothies", price: "49K" },
      { name: "Strawberry Smoothies", price: "49K" },
      { name: "Mango Smoothies", price: "49K" },
      { name: "Mix Smoothies", price: "49K" },
      { name: "Dragon Banana Smoothies", price: "49K" },
      { name: "Apple Smoothies", price: "49K" }
    ]
  },
  {
    title: "Milkshake",
    items: [
      { name: "Vanilla Milkshake", price: "45K" },
      { name: "Strawberry Milkshake", price: "45K" },
      { name: "Chocolate Milkshake", price: "45K" }
    ]
  },
  {
    title: "Special Tea",
    items: [
      { name: "Lemongrass Tea", price: "35K" },
      { name: "Apple Tea", price: "35K" },
      { name: "Lychee Tea", price: "35K" },
      { name: "Lemon Tea", price: "35K" },
      { name: "Peach Tea", price: "35K" },
      { name: "Green Tea", price: "35K" },
      { name: "Jasmine Tea", price: "35K" },
      { name: "Black Tea", price: "35K" },
      { name: "Ginger Tea", price: "35K" }
    ]
  },
  {
    title: "Herbal",
    items: [
      { name: "Blood of Patal", price: "65K", description: "Carrot, orange, warm ginger and tummeric" },
      { name: "Green Clean", price: "65K", description: "Malang green apple, pineapple, capsicum, spinach, pennel and coconut water" },
      { name: "Coconuts Funch", price: "65K", description: "Longan fruit, peach fruit, lychee fruit, lime juice, coconut water" },
      { name: "Sidemen Detox", price: "65K", description: "Green cucumber, strawberry, tropical pineapple, bell pepper, and mint leaves" }
    ]
  },
  {
    title: "Special Coffe",
    subtitle: "Hot Coffe",
    items: [
      { name: "Americano", price: "45K" },
      { name: "Espresso", price: "30K" },
      { name: "Double Espresso", price: "50K" },
      { name: "Cappucino", price: "45K" },
      { name: "Flat White", price: "45K" },
      { name: "Cafe Latte", price: "45K" },
      { name: "Matcha Latte", price: "40K" },
      { name: "Mocha Latte", price: "55K" },
      { name: "Espresso Maciato", price: "40K" },
      { name: "Mochacino", price: "50K" },
      { name: "Piccolo", price: "35K" },
      { name: "Affogato", price: "45K" },
      { name: "Chocolate", price: "40K" }
    ]
  },
  {
    title: "Iced Coffe",
    items: [
      { name: "Cappucino", price: "45K" },
      { name: "Americano", price: "45K" },
      { name: "Mochacino", price: "45K" },
      { name: "Long Black", price: "45K" },
      { name: "Cafe Latte", price: "45K" },
      { name: "Mocha Latte", price: "45K" },
      { name: "Matcha Latte", price: "45K" },
      { name: "Chocolate", price: "45K" }
    ]
  },
  {
    title: "Additional Charge",
    items: [
      { name: "Oat Milk", price: "15K" },
      { name: "Soya Milk", price: "15K" },
      { name: "Almond Milk", price: "15K" },
      { name: "Caramel", price: "15K" },
      { name: "Vanila", price: "15K" }
    ]
  },
  {
    title: "Mocktail",
    items: [
      { name: "Peach Vibes", price: "65K", description: "Peach syrup, peach fruit, honey, grenadine" },
      { name: "Strawberry On Filed", price: "67K", description: "Fresh strawberry, mint spring, lemon grass, homemade rosella syrup, soda", isBestSeller: true },
      { name: "Passionate Lychee", price: "67K", description: "Orange juice, passion syrup, lychee fruits and lychee reduction" },
      { name: "Sparkling Mint Lemonade", price: "67K", description: "Fresh wedges lime, mint leaf, simple syrup, top with soda water" },
      { name: "Strawberry Lychee Soda", price: "67K", description: "Strawberry syrup, fresh slice lychee, fresh lime juice and soda" },
      { name: "Peach Sangria", price: "67K", description: "Peach syrup, pineapple juice, lime juice, and top with soda water", isBestSeller: true },
      { name: "The Rainbow", price: "75K", description: "Strowberry, fresh milk, matcha, top milk foam" },
      { name: "Co Range", price: "89K", description: "Espresso, orange juice, simple syrup, top with tonik water" },
      { name: "Caffein Fulled", price: "75K", description: "Banana, espresso, milk, simple sirup" },
      { name: "Ultra Violet", price: "75K", description: "Lychee, lemon juice, dragon fruit, top with tonik" }
    ]
  },
  {
    title: "Cocktail",
    items: [
      { name: "Lemonade Frozen", price: "96K", description: "Bacardi rum, triple sec, mint leave, simple syrup, lime juice" },
      { name: "Dedari", price: "76K", description: "Palm spirit, lemongrass, lychee, homemade spice syrup, rossela top with soda" },
      { name: "Taksu", price: "98K", description: "Lemongrass syrup, infused rossela, spicy syrup, vodka, cointreau, arak top soda water" },
      { name: "Vodka Lemongrass", price: "87K", description: "Vodka, sugar, lemongrass, lime" },
      { name: "Patal Sunrise", price: "80K", description: "Vodka, orange juice, lime juice, grenadine, simple syrup" },
      { name: "Margarita Cocktail", price: "98K", description: "Tequila, triple sec and sweet sour choose your flavor: Strawberry, Mango or Frozen" },
      { name: "Mojito", price: "97K", description: "Light rum, lime juice, mint leaves, sugar, and soda choose your flavor: Passion fruits, lychee, peach or strawberry" },
      { name: "Cosmopolitan", price: "83K", description: "Vodka, cointreau, sour mix and canberry juice" },
      { name: "Lychee-Rose Martini", price: "83K", description: "Gin, rosella reduction, lychee and sweet vermouth" },
      { name: "Pina Collada", price: "89K", description: "Light rum, coconut rum, pineapple juice and coconut milk" },
      { name: "Jhon Collins", price: "100K", description: "Jhonie walker red, fresh squeeze lime juice, top with soda" },
      { name: "Whiskey Sour", price: "100K", description: "Jim beam bourbon, simple syrup and fresh lime juice" },
      { name: "Mai Tai", price: "98K", description: "Bacardi rum, amaretto disarono, prange juice, pineapple juice, top with myers rum", isBestSeller: true },
      { name: "Peartini", price: "98K", description: "Vodka, cointreau, peach syrup, and fresh lime juice" },
      { name: "Patal Blue Butterfly", price: "98K", description: "Infused butterfly, Bacardi rum, blue curacao, triple sec, myers rum, lemon juice and soda" },
      { name: "Patal Collada", price: "89K", description: "Pineapple jc, mango juice, coconut milk, simple syrup, cointreau, myers rum" },
      { name: "Bitter Sweet Sour", price: "100K", description: "Coffe liquer, simple syrup, vodka, cointreau angustura bitter and tonic water" },
      { name: "Camories", price: "115K", description: "Campari, lemon juice, lime juice, vodka, cointreau and soda" },
      { name: "Cream De Cacuo", price: "89K", description: "Cream liquer, coffe liquer, simple syrup, coconut milk, angustura bitter and soda" },
      { name: "Singapore Sling", price: "120K", description: "Gordon gin, cherry brandy, benedictine, bitter, lime juice, pineapple juice, splas of soda" },
      { name: "Honey Mountain", price: "76K", description: "Bacardi rum, triple sec, mint leave, simple syrup, lime juice", isBestSeller: true },
      { name: "Aurora In The Sky", price: "96K", description: "Strowberry, vodka, blue curacao, lemon juice, top with tonik" },
      { name: "Orange Flush", price: "98K", description: "Rum, triple sec, peach syrup, top with tonik" },
      { name: "Red Heart", price: "98K", description: "Campari, cerry brandy, lime juice, tequila, top with tonik" },
      { name: "Hot Spicy", price: "98K", description: "Tequila, rum, spicy syrup, ginger, arak, lime juice, top with tonik" }
    ]
  }
];
